<div class="main-content">
  <div *ngIf="canRead()">

    <!-- Header -->
    <div class="header-section">
      <div class="d-flex justify-content-between align-items-center">
        <div class="wm-heading">
          <div class="wm-heading-icon"><i class="fas fa-file-excel"></i></div>
          <div>
            <h1 class="main-title">Inserimento Massivo Dealer</h1>
            <p class="main-subtitle">Importa dealer tramite file Excel e gestisci l'anagrafica</p>
          </div>
        </div>
        <button class="btn btn-template" (click)="downloadTemplate()" [disabled]="isDownloadingTemplate"
          title="Scarica il template Excel da compilare">
          <i class="fas me-2"
             [class.fa-download]="!isDownloadingTemplate"
             [class.fa-spinner]="isDownloadingTemplate"
             [class.fa-spin]="isDownloadingTemplate"></i>
          Scarica Template
        </button>
      </div>
    </div>

    <!-- ── SEZIONE 1: Upload ── -->
    <div class="card mb-4">
      <div class="card-header">
        <div class="header-title">
          <i class="fas fa-file-excel header-icon"></i>
          <h3>Carica File Excel</h3>
        </div>
      </div>
      <div class="card-body">

        <!-- Drop Zone -->
        <div class="drop-zone"
          [class.drag-over]="isDragOver"
          [class.has-file]="selectedFile"
          (dragover)="onDragOver($event)"
          (dragleave)="onDragLeave($event)"
          (drop)="onDrop($event)">

          <ng-container *ngIf="!selectedFile">
            <div class="drop-zone-icon"><i class="fas fa-cloud-upload-alt"></i></div>
            <p class="drop-zone-text">Trascina il file qui</p>
            <p class="drop-zone-sub">oppure</p>
            <label class="btn-select-file" for="fileInput">
              <i class="fas fa-folder-open me-2"></i> Seleziona file
            </label>
            <input type="file" id="fileInput" accept=".xls,.xlsx" class="d-none" (change)="onFileSelected($event)">
            <p class="drop-zone-hint mt-2">Formati supportati: .xls, .xlsx</p>
          </ng-container>

          <ng-container *ngIf="selectedFile">
            <div class="file-preview">
              <div class="file-preview-icon"><i class="fas fa-file-excel text-success"></i></div>
              <div class="file-preview-info">
                <span class="file-name">{{ selectedFile.name }}</span>
                <span class="file-size text-muted">{{ formatFileSize(selectedFile.size) }}</span>
              </div>
              <button type="button" class="btn-remove-file" (click)="removeFile()" title="Rimuovi file">
                <i class="fas fa-times"></i>
              </button>
            </div>
          </ng-container>
        </div>

        <!-- Azioni -->
        <div class="upload-actions-row mt-3">

          <!-- Risultato inline (a sinistra, flex:1) -->
          <div class="result-box" *ngIf="result">
            <div class="result-stats">
              <div class="stat-item stat-total">
                <span class="stat-value">{{ result.totalRows }}</span>
                <span class="stat-label">Totali</span>
              </div>
              <div class="stat-item stat-inserted">
                <span class="stat-value">{{ result.inserted }}</span>
                <span class="stat-label">Inseriti</span>
              </div>
              <div class="stat-item stat-skipped">
                <span class="stat-value">{{ result.skipped }}</span>
                <span class="stat-label">Saltati</span>
              </div>
              <div class="stat-item stat-errors">
                <span class="stat-value">{{ result.errors }}</span>
                <span class="stat-label">Errori</span>
              </div>
            </div>
            <div *ngIf="result.errors === 0" class="result-success">
              <i class="fas fa-check-circle me-1"></i> Nessun errore
            </div>
            <button *ngIf="result.errorDetails.length" type="button"
              class="btn-errors-toggle" (click)="toggleErrorDetails()">
              <i class="fas me-1"
                 [class.fa-chevron-down]="!showErrorDetails"
                 [class.fa-chevron-up]="showErrorDetails"></i>
              {{ showErrorDetails ? 'Nascondi errori' : result.errorDetails.length + ' errori' }}
            </button>
            <div *ngIf="showErrorDetails" class="error-details-list mt-2">
              <div *ngFor="let err of result.errorDetails; let i = index" class="error-detail-item">
                <span class="error-index">{{ i + 1 }}</span>
                <span class="error-text">{{ err }}</span>
              </div>
            </div>
          </div>

          <!-- Pulsanti (sempre a destra) -->
          <button type="button" class="btn btn-duplicates ms-auto" (click)="checkDuplicates()"
            [disabled]="!selectedFile || isCheckingDuplicates || isUploading"
            title="Analizza il file e individua dealer simili (soglia 80%)">
            <i class="fas me-2"
               [class.fa-copy]="!isCheckingDuplicates"
               [class.fa-spinner]="isCheckingDuplicates"
               [class.fa-spin]="isCheckingDuplicates"></i>
            {{ isCheckingDuplicates ? 'Analisi...' : 'Cerca Duplicati' }}
          </button>
          <button type="button" class="btn btn-reset" (click)="removeFile()"
            [disabled]="!selectedFile || isUploading">
            <i class="fas fa-undo me-2"></i> Reset
          </button>
          <button type="button" class="btn btn-upload" (click)="uploadFile()"
            [disabled]="!selectedFile || isUploading">
            <i class="fas me-2"
               [class.fa-upload]="!isUploading"
               [class.fa-spinner]="isUploading"
               [class.fa-spin]="isUploading"></i>
            {{ isUploading ? 'Caricamento...' : 'Avvia Importazione' }}
          </button>

        </div>

      </div>
    </div>

    <!-- ── SEZIONE 2: Dealer restituiti dal backend ── -->
    <div class="card">
      <div class="card-header">
        <div class="d-flex justify-content-between align-items-center">

          <!-- Sinistra: titolo + search -->
          <div class="d-flex align-items-center gap-3">
            <div class="header-title">
              <i class="fas fa-table header-icon"></i>
              <h3>Righe importate</h3>
            </div>
            <div class="search-container" *ngIf="allRows.length > 0">
              <div class="custom-search-wrapper">
                <i class="fas fa-search search-icon"></i>
                <input type="text" class="custom-search-input" placeholder="Cerca..."
                  [(ngModel)]="searchTerm" (ngModelChange)="applyFilter()">
                <button *ngIf="searchTerm" class="search-clear-btn" type="button"
                  (click)="searchTerm = ''; applyFilter()" title="Cancella ricerca">
                  <i class="fas fa-times"></i>
                </button>
              </div>
            </div>
          </div>

          <!-- Destra: controlli -->
          <div class="controls-container" *ngIf="allRows.length > 0">

            <!-- Filtro stato -->
            <div class="status-filter-group" *ngIf="result">
              <button class="status-filter-btn all" [class.active]="filterStatus === 'all'"
                (click)="setFilterStatus('all')">Tutti</button>
              <button class="status-filter-btn inserted" [class.active]="filterStatus === 'inserted'"
                (click)="setFilterStatus('inserted')">
                Inseriti <span class="filter-count">{{ result!.inserted }}</span>
              </button>
              <button class="status-filter-btn skipped" [class.active]="filterStatus === 'skipped'"
                (click)="setFilterStatus('skipped')" [disabled]="result!.skipped === 0">
                Saltati <span class="filter-count">{{ result!.skipped }}</span>
              </button>
              <button class="status-filter-btn error" [class.active]="filterStatus === 'error'"
                (click)="setFilterStatus('error')" [disabled]="result!.errors === 0">
                Errori <span class="filter-count">{{ result!.errors }}</span>
              </button>
            </div>

            <!-- Items per page -->
            <div class="btn-group btn-group-sm pagination-selector" role="group">
              <button *ngFor="let n of [10, 25, 50]" type="button" class="btn"
                [ngClass]="itemsPerPage === n ? 'btn-secondary' : 'btn-outline-secondary'"
                (click)="setItemsPerPage(n)" [title]="n + ' elementi per pagina'">{{ n }}</button>
            </div>

            <!-- Counter -->
            <div class="counter-display">
              <span class="badge bg-light text-muted">{{ filteredRows.length }}</span>
            </div>
          </div>

        </div>
      </div>


      <div class="card-body p-0">

        <!-- ── Vista duplicati ── -->
        <ng-container *ngIf="showDuplicatesView">

          <div class="duplicates-bar">
            <div class="duplicates-bar-info">
              <i class="fas fa-exclamation-triangle text-warning me-2"></i>
              <span *ngIf="duplicatePairs.length > 0">
                <strong>{{ duplicatePairs.length }}</strong> coppie con similarità ≥ {{ similarityThreshold }}%
              </span>
              <span *ngIf="duplicatePairs.length === 0" class="text-success">
                Nessun duplicato trovato
              </span>
            </div>
            <div class="ms-auto d-flex gap-2">
              <button type="button" class="btn btn-sm btn-outline-success"
                (click)="exportDuplicates()" [disabled]="duplicatePairs.length === 0"
                title="Esporta coppie in Excel">
                <i class="fas fa-file-excel me-1"></i> Esporta Excel
              </button>
              <button type="button" class="btn btn-sm btn-outline-secondary" (click)="exitDuplicatesView()">
                <i class="fas fa-arrow-left me-1"></i> Torna alla lista
              </button>
            </div>
          </div>

          <div class="table-responsive" *ngIf="duplicatePairs.length > 0">
            <table class="table table-hover mb-0">
              <thead>
                <tr>
                  <th style="width:36px;">#</th>
                  <th style="width:70px;" class="text-center">Sim.</th>
                  <th>Riga A</th>
                  <th>Codice A</th>
                  <th>Nome A</th>
                  <th>Indirizzo A</th>
                  <th>CAP / Città / Prov.</th>
                  <th class="dup-separator"></th>
                  <th>Riga B</th>
                  <th>Codice B</th>
                  <th>Nome B</th>
                  <th>Indirizzo B</th>
                  <th>CAP / Città / Prov.</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let pair of duplicatePairs; let i = index">
                  <td class="text-muted small">{{ i + 1 }}</td>
                  <td class="text-center">
                    <span class="sim-badge" [ngClass]="simClass(pair.similarity)">
                      {{ simPercent(pair.similarity) }}
                    </span>
                  </td>
                  <!-- Dealer A -->
                  <td class="text-muted small">{{ pair.rowA }}</td>
                  <td><code class="dealer-code">{{ pair.dealerCodeA || '-' }}</code></td>
                  <td class="fw-medium" [title]="simPercent(pair.similarityName) + ' sim. nome'">
                    {{ pair.dealerNameA || '-' }}
                  </td>
                  <td class="text-muted small" [title]="simPercent(pair.similarityStreet) + ' sim. indirizzo'">
                    {{ pair.dealerLegalAddressStreetA || '-' }}
                  </td>
                  <td class="text-muted small">
                    <span [title]="simPercent(pair.similarityZip) + ' sim. CAP'">{{ pair.dealerLegalAddressZipA || '-' }}</span>
                    /
                    <span [title]="simPercent(pair.similarityCity) + ' sim. città'">{{ pair.dealerLegalAddressCityA || '-' }}</span>
                    /
                    <span [title]="simPercent(pair.similarityProvince) + ' sim. prov.'">{{ pair.dealerLegalAddressProvinceA || '-' }}</span>
                  </td>
                  <!-- Separatore -->
                  <td class="dup-separator"><i class="fas fa-arrows-alt-h text-muted"></i></td>
                  <!-- Dealer B -->
                  <td class="text-muted small">{{ pair.rowB }}</td>
                  <td><code class="dealer-code">{{ pair.dealerCodeB || '-' }}</code></td>
                  <td class="fw-medium" [title]="simPercent(pair.similarityName) + ' sim. nome'">
                    {{ pair.dealerNameB || '-' }}
                  </td>
                  <td class="text-muted small" [title]="simPercent(pair.similarityStreet) + ' sim. indirizzo'">
                    {{ pair.dealerLegalAddressStreetB || '-' }}
                  </td>
                  <td class="text-muted small">
                    <span [title]="simPercent(pair.similarityZip) + ' sim. CAP'">{{ pair.dealerLegalAddressZipB || '-' }}</span>
                    /
                    <span [title]="simPercent(pair.similarityCity) + ' sim. città'">{{ pair.dealerLegalAddressCityB || '-' }}</span>
                    /
                    <span [title]="simPercent(pair.similarityProvince) + ' sim. prov.'">{{ pair.dealerLegalAddressProvinceB || '-' }}</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="empty-state py-4" *ngIf="duplicatePairs.length === 0">
            <i class="fas fa-check-circle text-success"></i>
            <h4>Nessun duplicato trovato</h4>
            <p>Nessuna coppia supera la soglia del {{ similarityThreshold }}%</p>
          </div>

        </ng-container>

        <!-- ── Vista normale ── -->
        <ng-container *ngIf="!showDuplicatesView">

        <div class="table-responsive" *ngIf="paginatedRows.length > 0">
          <table class="table table-hover mb-0">
            <thead>
              <tr>
                <th style="width:36px;">#</th>
                <th *ngIf="result" style="width:100px;">Stato</th>
                <th class="sortable-header" (click)="sortBy('dealerCode')">
                  Codice <i class="fas" [ngClass]="getSortIcon('dealerCode')"
                    [class.text-primary]="sortColumn === 'dealerCode'"></i>
                </th>
                <th class="sortable-header" (click)="sortBy('dealerName')">
                  Ragione Sociale <i class="fas" [ngClass]="getSortIcon('dealerName')"
                    [class.text-primary]="sortColumn === 'dealerName'"></i>
                </th>
                <th class="sortable-header" (click)="sortBy('dealerClientCode')">
                  Client <i class="fas" [ngClass]="getSortIcon('dealerClientCode')"
                    [class.text-primary]="sortColumn === 'dealerClientCode'"></i>
                </th>
                <th class="sortable-header" (click)="sortBy('dealerBrandCode')">
                  Brand <i class="fas" [ngClass]="getSortIcon('dealerBrandCode')"
                    [class.text-primary]="sortColumn === 'dealerBrandCode'"></i>
                </th>
                <th class="sortable-header" (click)="sortBy('dealerVatNumber')">
                  P.IVA <i class="fas" [ngClass]="getSortIcon('dealerVatNumber')"
                    [class.text-primary]="sortColumn === 'dealerVatNumber'"></i>
                </th>
                <th class="sortable-header" (click)="sortBy('dealerLegalAddressCity')">
                  Città <i class="fas" [ngClass]="getSortIcon('dealerLegalAddressCity')"
                    [class.text-primary]="sortColumn === 'dealerLegalAddressCity'"></i>
                </th>
                <th>Prov.</th>
                <th>Zona</th>
                <th class="text-center">KPI</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let row of paginatedRows; let i = index"
                [class.row-inserted]="row.rowStatus === 'inserted'"
                [class.row-skipped]="row.rowStatus === 'skipped'">

                <td class="text-muted small">{{ (currentPage - 1) * itemsPerPage + i + 1 }}</td>

                <td *ngIf="result">
                  <span class="row-status-badge" [ngClass]="'badge-' + row.rowStatus">
                    <i class="fas me-1"
                       [class.fa-check]="row.rowStatus === 'inserted'"
                       [class.fa-forward]="row.rowStatus === 'skipped'"
                       [class.fa-times]="row.rowStatus === 'error'"></i>
                    {{ row.rowStatus === 'inserted' ? 'Inserito' :
                       row.rowStatus === 'skipped'  ? 'Saltato'  : 'Errore' }}
                  </span>
                </td>

                <td><code class="dealer-code">{{ row.dealerCode || '-' }}</code></td>
                <td class="fw-medium">{{ row.dealerName || '-' }}</td>
                <td><span class="badge-code">{{ row.dealerClientCode || '-' }}</span></td>
                <td><span class="badge-code">{{ row.dealerBrandCode || '-' }}</span></td>
                <td class="text-muted small">{{ row.dealerVatNumber || '-' }}</td>
                <td>{{ row.dealerLegalAddressCity || '-' }}</td>
                <td class="text-muted">{{ row.dealerLegalAddressProvince || '-' }}</td>
                <td>
                  <span *ngIf="row.dealerDeliveryZoneCode" class="badge-zone">{{ row.dealerDeliveryZoneCode }}</span>
                  <span *ngIf="!row.dealerDeliveryZoneCode" class="text-muted">-</span>
                </td>
                <td class="text-center">
                  <i *ngIf="row.dealerIsExcludedFromKpi === true"
                     class="fas fa-ban text-danger" title="Escluso da KPI"></i>
                  <i *ngIf="row.dealerIsExcludedFromKpi !== true"
                     class="fas fa-check text-success" title="Incluso in KPI"></i>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="empty-state py-4" *ngIf="allRows.length === 0">
          <i class="fas fa-file-excel"></i>
          <h4>Nessun dato disponibile</h4>
          <p>Carica un file Excel per visualizzare i dati importati</p>
        </div>

        <div class="empty-state py-4" *ngIf="allRows.length > 0 && filteredRows.length === 0">
          <i class="fas fa-filter"></i>
          <h4>Nessuna riga</h4>
          <p>Nessuna riga corrisponde ai filtri selezionati</p>
        </div>

        <!-- Pagination -->
        <div class="pagination-container" *ngIf="allRows.length > 0 && filteredRows.length > 0">
          <div class="pagination-controls">
            <button class="pagination-btn" (click)="goToPage(currentPage - 1)" [disabled]="currentPage === 1"
              title="Pagina precedente">
              <i class="fas fa-chevron-left"></i>
            </button>
            <div class="page-numbers">
              <button *ngFor="let page of getPageNumbers()" class="pagination-number"
                [class.active]="page === currentPage" (click)="goToPage(page)"
                [title]="'Vai alla pagina ' + page">{{ page }}</button>
            </div>
            <span class="pagination-info">
              {{ (currentPage - 1) * itemsPerPage + 1 }} -
              {{ currentPage * itemsPerPage > filteredRows.length ? filteredRows.length : currentPage * itemsPerPage }}
              di {{ filteredRows.length }}
            </span>
            <button class="pagination-btn" (click)="goToPage(currentPage + 1)" [disabled]="currentPage === totalPages"
              title="Pagina successiva">
              <i class="fas fa-chevron-right"></i>
            </button>
          </div>
        </div>

        </ng-container><!-- /vista normale -->

      </div>
    </div>

  </div>

  <div *ngIf="!canRead()" class="empty-state">
    <i class="fas fa-lock"></i>
    <h4>Accesso non autorizzato</h4>
  </div>
</div>
